import React from 'react'

import styles from './cardUtilityBar.module.scss'
import NavButton from '../../atoms/buttons/navButton/NavButton'
import Progressbar from '../../atoms/progressBar/ProgressBar'

type Props = {
  progress?: number
  progressColor?: string
  backText?: string
  backFunc?: $TSFixMeFunction
}

const CardUtilityBar = ({ progress, progressColor, backText, backFunc }: Props) => {
  return (
    <div className={styles.container}>
      {backText || backFunc ? (
        <div className={styles['back-button']}>
          <NavButton styleType='back' text={backText} onClick={backFunc} />
        </div>
      ) : (
        ''
      )}
      {progress ? (
        <div className={styles['progress-bar-container']}>
          <Progressbar progress={progress} color={progressColor} />
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default CardUtilityBar
